import React from 'react';
import { Outlet } from 'react-router-dom';
import { PageBreadcrumb } from '@/components/PageBreadcrumb';
import { useBreadcrumb } from '@/contexts/BreadcrumbContext';
import { useIsMobile } from '@/hooks/use-mobile';

export const AppLayout: React.FC = () => {
  const { items, rightContent } = useBreadcrumb();
  const isMobile = useIsMobile();

  return (
    <>
      {items.length > 0 && !isMobile && (
        <div className="border-b border-border" style={{ backgroundColor: 'var(--pm-bg-card)' }}>
          <div className="max-w-content" style={{ paddingLeft: '32px', paddingRight: '32px', paddingTop: '6px', paddingBottom: '6px' }}>
            <div className="flex items-center justify-between">
              <PageBreadcrumb items={items} />
              {rightContent}
            </div>
          </div>
        </div>
      )}
      <Outlet />
    </>
  );
};
